// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._hN1bkV1GJ33_Z {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: var(--ds-space-100, 8px) var(--ds-space-300, 24px);
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  text-decoration: none;
}
._hN1bkV1GJ33_Z:hover {
  color: var(--ds-text, #172b4d);
}
.bKkGw0n6yx4gTV {
  background-color: var(--ds-link, #0c66e4);
  color: var(--ds-text-inverse, #ffffff);
}
.bKkGw0n6yx4gTV:hover {
  background-color: var(--ds-background-brand-bold-hovered, #0055cc);
  color: var(--ds-text-inverse, #ffffff);
}
.sQDpSoiW_gODKN {
  display: flex;
  align-items: stretch;
  margin-left: auto;
}
`, ""]);
// Exports
export var buttonLink = `_hN1bkV1GJ33_Z`;
export var primaryButtonLink = `bKkGw0n6yx4gTV`;
export var buttonGroup = `sQDpSoiW_gODKN`;
export default ___CSS_LOADER_EXPORT___;
